<app-card *ngIf="work">
  <!-- Title -->
  <div class="grid grid-flow-col grid-cols-[80px_1fr_80px] print:flex print:justify-between">
    <!-- Company -->
    <div>
      <!-- ADP -->
      <app-logo-card *ngIf="work.company === 'ADP'"
        src="assets/logo-adp.webp"
        alt="ADP logo"></app-logo-card>
      <!-- Google -->
      <app-logo-card *ngIf="work.company === 'Google'"
        src="assets/logo-google.webp"
        alt="Google logo"></app-logo-card>
      <!-- NYT -->
      <app-logo-card *ngIf="work.company === 'The New York Times'"
        alt="The New York Times logo"
        src="assets/logo-nyt.webp"></app-logo-card>
    </div>
    <!-- Position -->
    <div class="flex place-content-center flex-col text-center print:flex-grow print:text-left print:pl-4">
      <h3 class="text-xl print:text-lg">
        {{work.position}}
        <span class="block text-sm print:inline-block">
          {{work.company}}
        </span>
      </h3>
    </div>
    <!-- Period -->
    <div
      class="flex place-content-center flex-col text-sm pr-4 print:whitespace-nowrap print:flex-row print:pr-0 print:items-center">
      {{work.startDate | date: 'MMM yyyy'}}
      <br class="print:hidden" />
      <span class="hidden print:inline">&nbsp;to&nbsp;</span>
      <span *ngIf="work.endDate == 'Current'">Present</span>
      <span *ngIf="work.endDate != 'Current'">{{work.endDate | date: 'MMM yyyy'}}</span>
    </div>
  </div>
  <!-- Summary -->
  <h4
    class="px-4 bg-gray-50 text-lg shadow border border-y-gray-300 py-1 print:mt-2 print:p-0 print:border-0 print:shadow-none print:bg-white print:text-sm">
    {{work.summary}}
  </h4>

  <!-- Highlights -->
  <div class="p-4 pt-0 print:p-0 leading-relaxed text-base print:text-xs">
    <p *ngFor="let highlight of work.highlights"
      class="pt-3">
      {{highlight}}
    </p>
  </div>
</app-card>